
import { Logo } from "@/components/ui/Logo";
import { Instagram } from "lucide-react";

export const IndexFooter = () => {
  return (
    <footer className="container mx-auto px-4 py-6 md:py-8 mt-12 md:mt-16 border-t border-gray-200 dark:border-gray-700 bg-slate-100">
      <div className="flex flex-col items-center gap-4 md:gap-6 text-center">
        <Logo size="md" showIcon={true} />
        <div className="flex items-center gap-4">
          <a 
            href="https://instagram.com" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-600 dark:text-gray-400 hover:text-brand-teal transition-colors p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" 
            aria-label="Siga-nos no Instagram"
          >
            <Instagram className="h-5 w-5 md:h-6 md:w-6" />
          </a>
        </div>
        <p className="text-sm md:text-base text-gray-600 dark:text-gray-400 px-4">
          &copy; 2024 Conversion Bonus. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
};
